import {Component, Input, Output, EventEmitter, ViewChild, OnInit, HostListener} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ConstantsService} from '../../../../services/constants.service';
import {Office} from '../../../../types/admin-data.types';
import {ManagementCompanyService} from '../services/management-company.service';
import {UrlService} from '../../../../services/url.service';

declare const swal;
declare const toastr;

@Component({
    selector: 'office-modal',
    templateUrl: 'office-modal.component.html',
    styleUrls: ['office-modal.component.scss']
})
export class OfficeModalComponent implements OnInit {
    @ViewChild('form') form;
    @Output() onClose = new EventEmitter();
    @Output() onUpdate = new EventEmitter();
    @Input() data: Office = new Office();
    @Input('company-id') companyId: number;
    public disabledSubmit = false;

    constructor(public urlService: UrlService,
                private managementCompany: ManagementCompanyService) {}

    ngOnInit() {
        this.data = JSON.parse(JSON.stringify(this.data || new Office()));
        this.urlService.modalOpened.emit();
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.name) toastr.warning('Name should not be blank.');
            if (!form.value.phone) toastr.warning('Phone should not be blank.');

            return;
        }

        const data: any = {
            name: form.value.name,
            phone: form.value.phone,
            company: this.companyId,
            members: this.data.members.map(m => ({name: m.name, phone: m.phone}))
        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.managementCompany.editOffice(this.data.id, data).subscribe(() => {
                this.updateView('Office successfully updated');
            }, () => {
                this.disabledSubmit = false;
            });
        } else {
            this.managementCompany.addOffice(data).subscribe(() => {
                this.updateView('Office successfully created');
            }, () => {
                this.disabledSubmit = false;
            });
        }
    }

    addNewMember() {
        this.data.members.push({name: '', phone: ''});
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.form.reset();
        this.close();
        this.onUpdate.emit();
    }

    close() {
        if (this.form.dirty) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => this.onClose.emit()
            );
        } else {
            this.onClose.emit();
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.close(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/office-modal/office-modal.component.ts